import React, { useEffect } from "react";
import {
    Box,
    Typography,
    TextField,

} from "@mui/material";
import VerificationEmail from '../../assets/email-verification.svg'
import "./Signup.css";
import { verification, resendOTP} from '../../services/apiService';
import { showToast } from "../Toast/CommonToast";
import ReusableButton from "../Reusable/PrimaryButton/PrimaryButton";
import { useNavigate } from "react-router-dom";
import LoaderWithBackdrop from "../Loader/loader";


const VerificationValidation = () => {
    const [otp, setOtp] = React.useState<string[]>(new Array(6).fill(""));
    const inputRefs = React.useRef<Array<HTMLInputElement | null>>([]);
    const [loading, setLoading] = React.useState(false);
    const navigate = useNavigate();
    const [otpPage, setOtpPage] = React.useState(true);
    const [error, setError] = React.useState('');
    const [alreadyEmail, setAlreadyEmail] = React.useState('');
    const [email, setEmail] = React.useState("");
    const RESEND_COOLDOWN_SECONDS = 59;
    const [resendCooldown, setResendCooldown] = React.useState(0);

    const formatCountdown = (seconds: number) => `00:${String(seconds).padStart(2, "0")}s`;
    const hasEmail = Boolean(email);
    const isResendDisabled = hasEmail && resendCooldown > 0;

useEffect(() => {
    if (resendCooldown <= 0) return;

    const intervalId = window.setInterval(() => {
        setResendCooldown((prev) => (prev <= 1 ? 0 : prev - 1));
    }, 1000);

    return () => window.clearInterval(intervalId);
}, [resendCooldown]);

    useEffect(()=>{
        const storedEmail = localStorage.getItem("email");
        if(storedEmail) {
            setEmail(storedEmail);
            setResendCooldown(RESEND_COOLDOWN_SECONDS);
        }
    }, [])


   const handleOtpChange = (index: number, value: string) => {
        // Only allow numbers
        if (value && !/^\d$/.test(value)) return;

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        // Move to next input if value is entered
        if (value && index < 5) {
            inputRefs.current[index + 1]?.focus();
        }
    };

    const handleOtpKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
        // Move to previous input on backspace if current input is empty
        if (e.key === 'Backspace' && !otp[index] && index > 0) {
            inputRefs.current[index - 1]?.focus();
        }
    };

    const handleOtpPaste = (e:any) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData('text').slice(0, 6);
        const newOtp = [...otp];
        
        for (let i = 0; i < pastedData.length; i++) {
            if (/^\d$/.test(pastedData[i])) {
                newOtp[i] = pastedData[i];
            }
        }
        
        setOtp(newOtp);
        
        // Focus on the next empty box or last box
        const nextIndex = Math.min(pastedData.length, 5);
        inputRefs.current[nextIndex]?.focus();
    };
 const handleVerify = async () => {
        const otpValue = otp.join('');
        if(!otpValue || otpValue.length < 6){
            showToast("Please enter a valid 6-digit OTP", 'error');
            return;
        }
        setLoading(true);
        try {
            const payload ={
                otp: otpValue
            }
            const verifyOTP = await verification(payload);
            console.log("verifyOTP", verifyOTP)
            if (verifyOTP?.status === 'true') {
                setLoading(false);
                showToast(verifyOTP?.message, 'success');
                localStorage.setItem("accessToken", verifyOTP?.data?.token);
                localStorage.setItem("refreshToken", verifyOTP?.data?.refreshToken);
                localStorage.setItem("name", verifyOTP?.data?.name);
                localStorage.setItem("userId", verifyOTP?.data?._id);
                localStorage.setItem("email", verifyOTP?.data?.email);
                localStorage.setItem("isVerified", verifyOTP?.data?.isVerified);
                navigate('/home')
            } else {
                setLoading(false);
                showToast(verifyOTP?.message, 'error');
            }
        } catch (error:any) {
            setLoading(false);
            console.error('Verification error:', error);
            showToast(error?.message, 'error');
        }
    };

    const handleBackToLogin = () => {
        navigate('/login');
    }

    const validEmail = (email:any) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email) {
            setError('Email is required');
            return false;
        }
        if (!emailRegex.test(email)) {
            setError('Please enter a valid email');
            return false;
        }
        setError('');
        return true;
    };

    const handleEmailSend = async () => {
        if (validEmail(alreadyEmail)) {
            setLoading(true);
            try {
                const payload ={
                    email: alreadyEmail
                }
                const response = await resendOTP(payload);
                setLoading(false);
                if (!response.data?.isVerified) {
                    setEmail(alreadyEmail || response?.data?.email || response?.email);
                    localStorage.setItem("email", alreadyEmail || response?.data?.email || response?.email);
                    showToast(response.message || response?.data?.message, 'success');
                    setOtpPage(true);
                    setResendCooldown(RESEND_COOLDOWN_SECONDS);
                } else {
                    showToast(response?.message, 'success');
                    navigate('/login');
                }
            } catch (error:any) {
                setLoading(false);
                showToast(error.message, 'error');
            } finally {
                setLoading(false);
            }
        }

    }

    // const desktop = window.innerWidth > 1440 
    return (
        <>
        {loading &&  <LoaderWithBackdrop open={loading} />}
            <Box className="maincontainer">

                 <Box className="imagecontainer">
                </Box>

                <Box className="leftcontainer">
                    <Box sx={{ maxWidth: { xs: 350, md: 400, lg: 'fullwidth', xl: 500 }, width: "100%" }}>
                        <Box sx={{ textAlign: "left", marginBottom: 3 }}>
                            <img
                                src={'/assets/showcasaNew.svg'}
                                alt="Logo"
                                className="showcasalogo"
                            />

                        </Box>
                        {otpPage ?<>
                        <Typography
                            variant="h4"
                            className="login-verify"
                        >
                           OTP Verification
                        </Typography>
                        <Typography
                            variant="h4"
                            className="login-des"
                        >
                            We’ve sent an email to ’{email}’. Check your inbox to activate your account.
                        </Typography>
                        <Box className='login-container'>
                            <Box sx={{ 
                                display: 'flex', 
                                gap: '12px', 
                                justifyContent: 'flex-start',
                                marginBottom: '20px',
                                width:'100%'
                            }}>
                                {otp.map((digit, index) => (
                                    <input
                                        key={index}
                                        ref={(el) => (inputRefs.current[index] = el)}
                                        type="text"
                                        maxLength={1}
                                        value={digit}
                                        onChange={(e) => handleOtpChange(index, e.target.value)}
                                        onKeyDown={(e) => handleOtpKeyDown(index, e)}
                                        onPaste={handleOtpPaste}
                                        className='otp-input'
                                        onFocus={(e) => e.target.style.borderColor = '#4A4E7C'}
                                        onBlur={(e) => e.target.style.borderColor = '#4A4E7C'}
                                    />
                                ))}
                               
                            </Box>

                            <Box sx={{width: '80%'}}>
                                <ReusableButton sx={{width: '100%'}} onClick={handleVerify} >Verify OTP</ReusableButton>
                            </Box>
                             {/* <Typography variant="body2" className='extra-login-text' gutterBottom>Didn’t receive or entered an invalid OTP?{" "}
                                <span className='login-resend' onClick={() => {
                                    setOtpPage(false)
                                    setAlreadyEmail("")
                                }}>Resend it</span>
                            </Typography> */}
                            <Typography variant="body2" className="login-short" gutterBottom>
    Didn’t receive or entered an invalid OTP?{" "}
    <span
        className={`login-resend${isResendDisabled ? " disabled" : ""}`}
        onClick={() => {
            if (isResendDisabled) return;
            setOtpPage(false);
            setAlreadyEmail("");
        }}
        aria-disabled={isResendDisabled}
    >
        Resend it
    </span>
        <span className="login-resend-countdown">{formatCountdown(resendCooldown)}</span>
</Typography>
<Typography variant="body2" className='login-short' gutterBottom>Back to
                                <span className='login-resend-timer' onClick={() => handleBackToLogin()}>Sign in</span>
                            </Typography>
                        </Box>
                        </>:(
                        <>
                        <Typography
                            variant="h4"
                            className="login-title"
                        >
                            Please complete your OTP verification to continue 
                        </Typography>
                         <Box className='verification-container'>
                            <TextField
                                label="Email Address"
                                fullWidth
                                className='textField verification-email'
                                value={alreadyEmail}
                                error={!!error}
                                helperText={error}
                                margin="normal"
                                onChange={(e) => {
                                    setAlreadyEmail(e.target.value);
                                    if (error) {
                                        setError('');
                                    }
                                }}
                            />
                            <ReusableButton onClick={handleEmailSend}>Continue</ReusableButton>
                            <Typography variant="body2" className='extra-login-text' gutterBottom>Back to
                                <span className='login-resend-timer' onClick={() => handleBackToLogin()}>Sign in</span>
                            </Typography>
                        </Box>
                        </>
                        )}
                    </Box>
                </Box>
            </Box>
        </>
    )
}

export default VerificationValidation